<agr-page>
  <mat-vertical-stepper linear id="stepper">
    <mat-step [stepControl]="applicationGroupFormGroup">
      <form [formGroup]="applicationGroupFormGroup">
        <ng-template matStepLabel>{{
          'wizard_step1SelectApplicationGroup' | translate
        }}</ng-template>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'wizard_applicationGroups' | translate }}</mat-label>
          <mat-select formControlName="appGroupNameCtrl" required>
            <mat-option
              *ngFor="let applicationGroup of applicationGroups$ | async"
              [value]="applicationGroup"
            >
              {{ applicationGroup.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <button color="primary" mat-button matStepperNext>{{ 'wizard_next' | translate }}</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="applicationNameFormGroup">
      <form [formGroup]="applicationNameFormGroup">
        <ng-template matStepLabel>{{
          'wizard_step2CreateApplicationName' | translate
        }}</ng-template>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'wizard_applicationName' | translate }}</mat-label>
          <input
            matInput
            formControlName="appNameCtrl"
            placeholder="{{ 'wizard_applicationName' | translate }}"
            required
          />
        </mat-form-field>
        <div>
          <button mat-button matStepperPrevious>{{ 'wizard_back' | translate }}</button>
          <button mat-button matStepperNext>{{ 'wizard_next' | translate }}</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="applicationDescriptionFormGroup">
      <form [formGroup]="applicationDescriptionFormGroup">
        <ng-template matStepLabel>{{
          'wizard_step3EnterApplicationDescription' | translate
        }}</ng-template>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'wizard_applicationDescription' | translate }}</mat-label>
          <textarea
            matInput
            formControlName="appDescriptionCtrl"
            placeholder="{{ 'wizard_applicationDescription' | translate }}"
            required
          ></textarea>
        </mat-form-field>
        <div>
          <button mat-button matStepperPrevious>{{ 'wizard_back' | translate }}</button>
          <button mat-button matStepperNext>{{ 'wizard_next' | translate }}</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="applicationRoleFormGroup">
      <form [formGroup]="applicationRoleFormGroup">
        <ng-template matStepLabel>{{
          'wizard_step4SelectApplicationRole' | translate
        }}</ng-template>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'wizard_applicationRoles' | translate }}</mat-label>
          <mat-select formControlName="appRoleNameCtrl" required>
            <mat-option
              *ngFor="let applicationRole of applicationRoles$ | async"
              [value]="applicationRole"
            >
              {{ applicationRole.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button color="primary" mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="applicationDisallowedRoleFormGroup">
      <form [formGroup]="applicationDisallowedRoleFormGroup">
        <ng-template matStepLabel>{{
          'wizard_step5SelectApplicationRole' | translate
        }}</ng-template>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'wizard_applicationRoles' | translate }}</mat-label>
          <mat-select formControlName="appDisallowedRoleNameCtrl">
            <mat-option>None</mat-option>
            <mat-option value="ContactPerson">ContactPerson</mat-option>
            <mat-option value="Employee">Employee</mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button color="primary" mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'wizard_step6RegisterApplication' | translate }}</ng-template>
      <p>{{ 'wizard_createMessage' | translate }}</p>
      <ul class="app-highlights">
        <li>
          {{ 'wizard_applicationTitled' | translate }}
          <b>{{ applicationNameFormGroup.get('appNameCtrl').valueChanges | async }}</b>
        </li>
        <li>
          {{ 'wizard_description' | translate }}:
          <b>{{
            applicationDescriptionFormGroup.get('appDescriptionCtrl').valueChanges | async
          }}</b>
        </li>
        <li>
          {{ 'wizard_underApplicationGroup' | translate }}:
          <b>{{ applicationGroupFormGroup.get('appGroupNameCtrl').valueChanges | async }}</b>
        </li>
        <li>
          {{ 'wizard_withDefaultRoleApplicationRoleName' | translate }}:
          <b>{{ applicationRoleFormGroup.get('appRoleNameCtrl').valueChanges | async }}</b>
        </li>
        <li>
          {{ 'wizard_withDisallowedRoleApplicationProfileType' | translate }}:
          <b>{{
            applicationDisallowedRoleFormGroup.get('appDisallowedRoleNameCtrl').valueChanges | async
          }}</b>
        </li>
      </ul>
      <div>
        <button mat-button matStepperPrevious>{{ 'wizard_back' | translate }}</button>
        <button mat-button (click)="stepper.reset()">{{ 'wizard_reset' | translate }}</button>
        <button mat-button color="primary" (click)="complete()">
          {{ 'wizard_complete' | translate }}
        </button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'wizard_step7Complete' | translate }}</ng-template>
      <p>{{ 'wizard_registrationSuccessMessage' | translate }}</p>
    </mat-step>
  </mat-vertical-stepper>
</agr-page>
